import { AcknowledgementName } from "@wingspanhq/wingspan-api-sdk";
import { acknowledgementsApi } from "@api";
import { acknowledgementVersions } from "../constants/acknowledgements";

export async function updateAcknowledgements(
  acknowledgements: AcknowledgementName[]
) {
  const acknowledgementPromises = acknowledgements.map(acknowledgementName =>
    acknowledgementsApi.acceptAcknowledgement({
      acknowledgementName,
      acceptAcknowledgementRequest: {
        version: acknowledgementVersions[acknowledgementName]
      }
    })
  );

  return await Promise.all(acknowledgementPromises);
}
